export default "__VITE_ASSET__DSkRG_pC__"